import React from "react";
import { Square5Style } from "./css/Square5Style";
import TemplateImage from "../../components/editor/Templates/TemplateImage";
import TemplateLogo from "../../components/editor/Templates/TemplateLogo";
import TemplateWatermark from "../../components/editor/Templates/TemplateWatermark";
import TemplateText from "../../components/editor/Templates/TemplateText";

const Template = (props) => {
  return (
    <Square5Style>
      <div className="poster one-by-one lg">
        <TemplateLogo logo={props.logo} />
        <TemplateWatermark watermark={props.watermark} />
        <div className="img-container flex-column">
          <TemplateImage slideType={props.slideType} file={props.file} />
        </div>
        <div className="cover" />
        <div className="text-wrapper flex-column">
          <TemplateText
            id={props.id}
            text={props.text}
            textStyle={props.textStyle}
            editStatus={props.editStatus}
            onInputSlideText={props.onInputSlideText}
          />
        </div>
      </div>
    </Square5Style>
  );
};

export default Template;
